import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Game from "@/pages/Game";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import CasinoMalaysia from "@/pages/CasinoMalaysia";
import Bonus from "@/pages/Bonus";
import U2Agent from "@/pages/U2Agent";
import U2Slots from "@/pages/U2Slots";
import U2News from "@/pages/U2News";
import NewsDetail from "@/pages/NewsDetail"; //[cite: 4]

import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/game" element={<Game />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/register" element={<Register />} />
              <Route path="/casino-malaysia" element={<CasinoMalaysia />} />
              <Route path="/bonus" element={<Bonus />} />
              <Route path="/u2-agent" element={<U2Agent />} />
              <Route path="/u2-slots" element={<U2Slots />} />
              <Route path="/u2-news" element={<U2News />} />
              {/* 关键修复：添加文章详情页路由[cite: 4] */}
              <Route path="/news/:id" element={<NewsDetail />} /> 
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </LanguageProvider>
    </div>
  );
}

export default App;
